import React from "react";
import styles from "./InstallmentPendingBottomSheet.module.scss";
import Button from "@src/components/UIElements/Button";
import { Image } from "@src/components/Image";
import Modal from "@src/components/UIElements/Modal";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import * as actionCreator from "../../store/actions";
import { getAwsAssets } from "@src/utils";
import { useTranslation } from "react-i18next";
import { directDeepLink } from "@src/common/deepLinks/index.js";
import { openInstallmentUtil } from "../../../Tabs/Overview/components/OverviewContent/utility";
import { newWebEngage } from "@src/utils/webEngageEvent";
const InstallmentPendingBottomSheet = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const state = useSelector(
    (state) => state.bottomSheetReducer?.showCourseLockedBottomSheet
  );
  const data = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course?.installments
  );
  const overViewData = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course
  );
  const paymentData = useSelector((state) => state?.overviewReducer);
  const webEngageEvent = () => {
    // console.log(paymentData, "paymentData");
    newWebEngage("course_pay_via_installments_with_pending_amount", {
      action: "Pending Instalments Click",
      course_name: `${overViewData?.details?.name}`,
      pending_instalment_amount: Number(paymentData?.individualInstallmentData?.purchaseButton?.amount / 100),
      course_price: Number(paymentData?.individualInstallmentData?.courseInfo?.priceSummary?.coursePrice / 100),
      final_amount: Number(paymentData?.individualInstallmentData?.courseInfo?.priceSummary?.effectivePrice / 100),
    });
  }
  return (
    <Modal
      showModal={state}
      handleClose={() => {
        dispatch(actionCreator.showCourseLockedBottomSheetAction(false));
      }}
    >
      <div className={styles.CourseLocked}>
        <div className={styles.CourseLocked__image}>
          <Image
            src={getAwsAssets("lockedIcon.svg", "bottomSheets")}
            width="68px"
            height="68px"
            alt={t(
              "components.bottomSheets.components.installmentPendingBottomSheet.lockedIcon",
              "lockedIcon"
            )}
          />
        </div>
        <h1 className={styles.CourseLocked__heading}>
          {data?.installmentAlert?.heading}
        </h1>
        <p className={styles.CourseLocked__subtext}>
          {data?.installmentAlert?.text}
        </p>
        <Button onClick={() => {
          openInstallmentUtil();
          webEngageEvent();
        }}>
          {data?.installmentPaymentData?.purchaseText}
        </Button>
        <p
          className={styles.CourseLocked__viewAllInst}
          onClick={() => openInstallmentUtil()}
        >
          {t(
            "components.bottomSheets.components.installmentPendingBottomSheet.viewAllInstallmentsText",
            "View All Installments"
          )}
        </p>
      </div>
    </Modal>
  );
};

export default InstallmentPendingBottomSheet;
